import { NgModule } from 'ng-metadata/core';
import { CheckoutCartItemComponent } from './cart-item.component';

@NgModule({
  declarations: [
    CheckoutCartItemComponent,
  ],
})
export class CheckoutCartItemModule { }



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/cart/item/cart-item.module.ts